import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import DescriptionIcon from '@mui/icons-material/Description';
import '../assets/styles/Main.scss';
import myphoto from '../assets/images/myphoto.jpg';

function Main() {
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={myphoto} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/baranidharan11" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/baranidharan-tamilarasan" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            <a href="mailto:baraniskt11@gmail.com" target="_blank" rel="noreferrer"><EmailIcon /></a>
            <a href="tel:9790504761" target="_blank" rel="noreferrer"><CallIcon /></a>
            <a href="/BaraniMernstack.pdf" download="BaraniMernstack.pdf" target="_blank" rel="noreferrer" className="download-link">
              <DescriptionIcon />
              
            </a>
          </div>
          <h1>BaraniDharan</h1>
          <p>Full Stack Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/baranidharan11" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/baranidharan-tamilarasan" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            <a href="mailto:baraniskt11@gmail.com" target="_blank" rel="noreferrer"><EmailIcon /></a>
            <a href="tel:9790504761" target="_blank" rel="noreferrer"><CallIcon /></a>
            <a href="/BaraniMernstack.pdf" download="BaraniMernstack.pdf" target="_blank" rel="noreferrer" className="download-link">
              <DescriptionIcon />
              
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
